import { LmmTijdstipLabel } from '../types/LmmVoorraad';

import { isLmmTijdstipNu } from './lmmTijdstippen';

/** A single column shown within an (open) tijdstip's column-group. */
export type LmmColumnKey =
  | 'benodigd'
  | 'dienst'
  | 'gdst'
  | 'ebksb'
  | 'nietInzetbaar'
  | 'verwachtNietInzetbaar'
  | 'verwachtGereed'
  | 'overOfTekort';

export const LMM_COLUMN_LABELS: Record<LmmColumnKey, string> = {
  benodigd: 'Benodigd',
  dienst: 'Dienst',
  gdst: 'GDST',
  ebksb: 'EBKSB',
  nietInzetbaar: 'Niet inzetbaar',
  verwachtNietInzetbaar: 'Verwacht niet inzetbaar',
  verwachtGereed: 'Verwacht gereed',
  overOfTekort: 'Over/tekort',
};

/**
 * Single source of truth for which columns a tijdstip's column-group renders, shared by the
 * headers row and every data row so they can never fall out of sync.
 * - Closed tijdstip: only 'Over/tekort'.
 * - Open tijdstip, Benodigd collapsed: 'Benodigd' + (Niet inzetbaar | Verwacht niet
 *   inzetbaar/Verwacht gereed) + 'Over/tekort'.
 * - Open tijdstip, Benodigd expanded: 'Dienst'/'GDST'/'EBKSB' instead of 'Benodigd'.
 */
export const getLmmTijdstipColumns = (
  label: LmmTijdstipLabel,
  openTijdstip: LmmTijdstipLabel | null,
  openBenodigdOpbouw: boolean,
): LmmColumnKey[] => {
  if (label !== openTijdstip) return ['overOfTekort'];

  const benodigdColumns: LmmColumnKey[] = openBenodigdOpbouw ? ['dienst', 'gdst', 'ebksb'] : ['benodigd'];
  const inzetbaarColumns: LmmColumnKey[] = isLmmTijdstipNu(label)
    ? ['nietInzetbaar']
    : ['verwachtNietInzetbaar', 'verwachtGereed'];

  return [...benodigdColumns, ...inzetbaarColumns, 'overOfTekort'];
};

export const getLmmTijdstipColumnCount = (
  label: LmmTijdstipLabel,
  openTijdstip: LmmTijdstipLabel | null,
  openBenodigdOpbouw: boolean,
): number => getLmmTijdstipColumns(label, openTijdstip, openBenodigdOpbouw).length;
